import { Injectable } from '@angular/core'
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { WebformsFormData } from '../../components/webforms-form/webforms-form.component.converter'
import { Observable } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'
import { environment } from '../../../../../environments/environment'
import { CmsEnvironmentService } from '../cms-environment.service'

@Injectable({
  providedIn: 'root'
})
export class MbWebformsService {

  constructor (private http: HttpClient,
               private cmsEnvService: CmsEnvironmentService) {
  }

  sendWebformsRequest (formData: WebformsFormData | undefined): Observable<HTMLFormElement | null> {
    const body = new URLSearchParams()
    body.set('_view', 'webform')
    body.set('_fd', formData?.fd ?? '')
    body.set('_lang', formData?.lang ?? '')
    body.set('_refs', formData?.refs ?? '')
    return this.getWebformsUrl().pipe(
      switchMap(webformsUrl => this.http.post(webformsUrl, body.toString(), {
          withCredentials: true, responseType: 'text',
          headers: new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded')
        }).pipe(
          catchError((e: any) => {
            console.error(e)
            return e
          }),
          map(formResponse => new DOMParser().parseFromString(formResponse as any, 'text/html')?.querySelector('form')),
        )
      )
    )
  }

  getWebformsUrl (): Observable<string> {
    return this.cmsEnvService.isFirstSpiritPreview$.pipe(
      map(isPreview => isPreview ? environment.webformsUrlPreview : this.cmsEnvService.sanitizeSsr(environment.webformsUrlLive))
    )
  }
}
